<div class="container-fluid mktg">
  <div class="row justify-content-center mktg-bg">
    <div class="col-12 col-lg-10">
      <div class="col-12 separator pdestacadas"></div>
      <div class="row justify-content-center">
        <div class="col-12 col-lg-9 text-center mt-5 title1">
          <h1>{{ "MKTG2" | translate }}</h1>
        </div>
        <div class="col-12 col-lg-9 text mt-4">
          <p>{{ "MKTG3" | translate }}</p>
        </div>
        <div class="col-11 col-lg-9 mt-5 mkim1"></div>
        <div class="col-11 col-lg-9 mkim2">
          <video id="video-element" autoplay loop muted>
            <source
              src="https://firebasestorage.googleapis.com/v0/b/batista-web.appspot.com/o/videos%2Focean2-web.mp4?alt=media&token=a7d78801-eb8a-4faa-bcd2-4b2155423cc1"
              type="video/mp4"
            />
            Tu navegador no admite la reproducción de videos.
          </video>
        </div>
        <div class="col-11 col-lg-9 mkim3"></div>
        <div class="col-6 mt-5 mb-5 text-center play">
          <a href="https://www.instagram.com/p/CuVG0WegscB/" target="_blank">
            <i class="fa-solid fa-circle-play fa-3x"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
